var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext as useReactContext, useState, } from 'react';
export var createContext = function (defaultValue) {
    var context = React.createContext(defaultValue);
    var useContext = function () { return useReactContext(context); };
    return __assign(__assign({}, context), { useContext: useContext });
};
export var createStateContext = function (defaultValue) {
    var _a = createContext([
        defaultValue,
        function () {
            // do nothing.
        },
    ]), DefaultProvider = _a.Provider, useContext = _a.useContext;
    var Provider = function (_a) {
        var children = _a.children;
        var state = useState(defaultValue);
        return React.createElement(DefaultProvider, { value: state }, children);
    };
    return { Provider: Provider, useContext: useContext };
};
//# sourceMappingURL=context.js.map